// extracted by mini-css-extract-plugin
export default {"cls1":"Z64Gr5Gsdw3dQUw8NjJW","cls2":"ZpMOOeuaP1tMoEv1OL68 Z64Gr5Gsdw3dQUw8NjJW"};